import { IconBubble } from 'ui';
import ImageBubble from 'core/modules/atoms/ImageBubble';
import CoreImage from 'core/variables/images';
import PropTypes from 'prop-types';
import React from 'react';

const LEGACY_TO_ICON_BUBBLE_SIZE = {
  big: 'xxl',
  default: 'md',
  l: 'xl',
  large: '3xl',
  medium: 'lg',
  s: 'sm',
  small: 'md',
  xs: 'xs',
};

function toIconBubbleSize(sizeBubble) {
  return LEGACY_TO_ICON_BUBBLE_SIZE[sizeBubble] ?? sizeBubble;
}

const ProgramImage = ({ configProgramPicture, calendarTheme, iconType, gradient, course_picture, sizeBubble, className, themeImage }) => {
  return (
    <>
      {!configProgramPicture && !themeImage && (
        <div className="program-image__bubble">
          <IconBubble className={className} gradient={gradient} name={iconType} size={toIconBubbleSize(sizeBubble)} variant="square" />
        </div>
      )}
      {!configProgramPicture && themeImage && (
        <div className="program-image__bubble">
          <ImageBubble size={sizeBubble} backgroundColor={gradient} imageUrl={themeImage} variant="square" />
        </div>
      )}
      {configProgramPicture && (
        <div
          className="program-image__picture-container"
          style={{ borderColor: calendarTheme ? calendarTheme.color : '', borderWidth: calendarTheme ? '2px' : '' }}
        >
          {
            <div
              className="program-image__picture"
              style={{ backgroundImage: `url(${course_picture ? course_picture : CoreImage.getImage('noPictureProgram')})` }}
            ></div>
          }
        </div>
      )}
    </>
  );
};

ProgramImage.propTypes = {
  sizeBubble: PropTypes.string,
};

ProgramImage.defaultProps = {
  sizeBubble: 'small',
};

export default ProgramImage;
